const decode = (data) => {
  // return decodeURIComponent(escape(atob(reverse(data.slice(0, -7)))))
  try {
    return decodeURIComponent(escape(atob(reverse(data.slice(0, -7)))))
  } catch (err) {
    return undefined
  }
}
const decodeToken = (data) => {
  try {
    return escape(atob(reverse(data.slice(0, -10)))).slice(0, -5)
  } catch (err) {
    return undefined
  }
}
function reverse (s) {
  return s.split('').reverse().join('')
}
export default {
  decode,
  decodeToken
}



// WEBPACK FOOTER //
// ./src/services/decode.js